import React, { Component } from 'react';
import { Header, Button } from 'semantic-ui-react'
import axios from 'axios'
import Select from 'react-select';
import { firebaseAuth, pythonApiIp, toCurrency, logComponentLoad } from '../../../../config/constants'
import createBrowserHistory from 'history/createBrowserHistory';
import LargeProjectsNav from './LargeProjectsNav';
import { getSalesPeopleDropDown } from './LargeProjectUtils'
import { getSalesPeople } from './ApiUtils'
import { RenderProjectList, RenderProjectCommSummary } from './UiUtils'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';



const history = createBrowserHistory({ forceRefresh: true });

function ShowExtraSalesCharges(props) {

    return (
        <div>
            <h4>extra sales charges</h4>
        </div>
    )
}

class ViewCurrentSales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            salesPeopleChoices: [],
            projects: [],
            commObject: '',
            loading: true,
            showCommissionButton: false,
            filter: "unpaid_comm",
            normalCharge: 0,
            totalCharges: 0,
            extraCharges: 0,
            algoliaUser: ''
        }
    }

    componentDidMount() {

        console.log("filltx1 ViewThisMonthCommission did mount")
        getSalesPeople(this.loadSalesPeople);

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            // console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)

                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    user: user,
                    uid: user.uid
                })

            }
        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("filltx1 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ViewCurrentSales");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        if (returnObject.algoliaUser.viewCommission) {
            console.log("filltx12 algoliaUser.viewCommission is true")
            this.getProjectListAndCommission()
            this.setState({ showCommissionButton: true })

        } else if (returnObject.algoliaUser.sales) {
            console.log("filltx121 algoliaUser.sales is true");
            this.setState({ salesPersonId: returnObject.algoliaUser.idadmins }, this.getProjectListAndCommission(returnObject.algoliaUser.idadmins, "unpaid_comm"))

        } else {
            console.log("filltx13 algoliaUser.viewCommission is FALSE, user not alloed to view commission")
            alert("unable to load - " + JSON.stringify(returnObject.algoliaUser, null, 3))
        }
    }

    loadSalesPeople = (salesPeople) => {
        // console.log("gts1 ++++++++:loadSalesPeopleDropdown");
        // console.log("gtc15:" + JSON.stringify(salesPeople, null, 3));
        if (salesPeople && salesPeople.length > 0) {
            console.log("gtc15 customer dropdown...")
            this.setState({
                salesPeopleChoices: getSalesPeopleDropDown(salesPeople)
            })
        } else {
            alert("unable to load customers")
        }
    }

    closesSalesPersonProjectsCommissionPaid = () => {
        console.log("commxx15 ++++++++:closesSalesPersonProjectsCommissionPaid");
        console.log("commxx152 salesPersonId:" + this.state.salesPersonId);

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'closesSalesPersonProjectsCommissionPaid', {
            apiKey: "asdfasdf",
            salesPersonId: this.state.salesPersonId,
            enteredBy: this.state.user.email
        })
            .then((response) => {

                if (response.data.result) {
                    console.log("filltx17 got results");

                    this.setState({
                        loading: false,
                    });

                    this.getProjectListAndCommission(this.state.salesPersonId, "unpaid_comm")

                } else {
                    console.log("FAILED");
                    this.setState({ loading: false })
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log("extt1:" + error);
                alert("Unable to load ext121:" + error)
                this.setState({ loading: false })
            });
    }

    getProjectListAndCommission = (salesPersonId, filter) => {
        console.log("commxx15 ++++++++:getProjectListAndCommission");
        console.log("commxx152 salesPersonId:" + salesPersonId);
        console.log("commxx153 filter:" + filter);

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getProjectList', {
            apiKey: "asdfasdf",
            filter: filter,
            salesPersonId: salesPersonId
        })
            .then((response) => {

                console.log("filltx16 results:" + JSON.stringify(response.data, null, 3));
                console.log("filltx164 results:" + JSON.stringify(response.data.commSummary, null, 3));
                console.log("filltx165 results:" + response.data.commSummary.profit);

                // let test = JSON.parse(response.data.commObject);
                // console.log("filltx166 results:" + test.numProject);

                if (response.data.result) {
                    console.log("filltx17 got results");

                    this.setState({
                        loading: false,
                        projects: response.data.projects,
                        commSummary: response.data.commSummary,
                        commSummaryWProjects: response.data.commSummaryWProjects
                        //commObject: response.data.commObject,
                        // }, console.log("filltx161 commObject:" + JSON.stringify(this.state.commSummary, null, 3)));
                    }, this.getExtraSalesCharge(response.data.commSummary.profit));



                } else {
                    console.log("FAILED");
                    this.setState({ loading: false })
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log("extt1:" + error);
                alert("Unable to load ext121:" + error)
                this.setState({ loading: false })
            });
    }

    //this.props.match.params.artist

    handleDropDownChanges = (value) => {
        // console.log("lst1 handleDropDownChanges");
        // console.log('lst12 You\'ve sss:', value);
        console.log("lst13 category alone:" + value.category);
        console.log('filltx16 You\'ve selected:', value.value + " " + value.category);
        // console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        // console.log("lst16 - array index:" + this.props.arrayIndex);

        this.setState({ salesPersonId: value.value }, this.getProjectListAndCommission(value.value, this.state.filter))

        // let newState = {};
        // newState[value.category] = value.value;
        // console.log("newState 1:" + JSON.stringify(newState, null, 3));

        // //this.setState(newState);
        // this.setState(newState,this.getProjectListAndCommission());
    }

    changeFilter = () => {
        if (this.state.filter == 'unpaid_comm') {
            console.log("commx2 this.state.filter == 'unpaid_comm' CHANGING TO unpaid_comm undelivered_orders");

            this.setState({
                filter: "undelivered_orders"
            }, this.getProjectListAndCommission(this.state.salesPersonId, "undelivered_orders"))

        } else if (this.state.filter == 'undelivered_orders') {
            console.log("commx2 this.state.filter == 'undelivered_orders' CHANGING TO unpaid_comm");

            this.setState({
                filter: "unpaid_comm"
            }, this.getProjectListAndCommission(this.state.salesPersonId, "unpaid_comm"))

        }
    }

    getExtraSalesCharge = (profit) => {
        console.log("getx1 ++++++ getExtraSalesCharge ++++")
        console.log("getx12 profit:" + profit);

        let extraCharges = 0;
        let standard = 4000000;

        if (profit > standard) {
            console.log("getx13 profit > " + standard);

            let normalCharges = standard * .10;
            console.log("getx14 normalCharges:" + normalCharges);

            console.log("getx15 (profit - standard):" + (profit - standard));

            extraCharges = (profit - standard) * .20;
            console.log("getx16 extraCharges:" + extraCharges);

            this.setState({
                normalCharges: normalCharges,
                extraCharges: extraCharges,
                totalCharges: (normalCharges + extraCharges)
            })

        } else {
            console.log("getx13 profit NOT > 4000000");

        }

        // return extraCharges
    }

    render() {

        const changeFilterButton = this.state.filter == "unpaid_comm"
            ? <div>
                <h4>COMPLETED ORDERS - UNPAID</h4>
                <Button color='teal' onClick={this.changeFilter}> VIEW INCOMPLETE ORDERS</Button>
            </div>
            : <div>
                <h4>UN COMPLETED ORDERS - NOT DELIVERED OR NOT PAID</h4>
                <Button color='green' onClick={this.changeFilter}> VIEW COMPLETE ORDERS</Button>
            </div>


        const salesPeopleDropDown = this.state.algoliaUser && this.state.algoliaUser.viewAllCommission && this.state.salesPeopleChoices.length > 0
            ? <div>
                <label>select sales Person {this.state.salesPersonId}</label>
                <Select
                    name="form-field-name"
                    value={this.state.salesPersonId}
                    options={this.state.salesPeopleChoices}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </div>
            : ''

        // const projectList = this.state.projects.length > 0
        //     ? <RenderProjectList projects={this.state.projects} loading={this.state.loading} />
        //     : ''

        // const projectDictList = this.state.commObject != '' && this.state.commObject.projectDictList && this.state.commObject.projectDictList.length > 0
        //     ? <RenderProjectDictList projects={this.state.commObject.projectDictList} loading={this.state.loading} user={this.state.user}/>
        //     : ''

        const projectCommSummary = this.state.commSummaryWProjects && this.state.commSummaryWProjects.length > 0
            ? <RenderProjectCommSummary projects={this.state.commSummaryWProjects} loading={this.state.loading} user={this.state.user} />
            : ''


        const numProjects = this.state.algoliaUser && this.state.algoliaUser.sales && this.state.commSummary
            ? <Header as='h2' color='blue'>
                {this.state.commSummary.idlargeprojects}
                <Header.Subheader>
                    Num Projects
        </Header.Subheader>
            </Header>
            : ''


        const totalProfit = this.state.algoliaUser && this.state.algoliaUser.sales && this.state.commSummary
            ? <Header as='h2' color='olive'>
                {toCurrency(this.state.commSummary.profit)}
                <Header.Subheader>
                    Total Profit
        </Header.Subheader>
            </Header>
            : ''

        // const totalCommission = this.state.algoliaUser && this.state.algoliaUser.sales && this.state.commSummary
        //     ? <Header as='h2' color='red'>
        //         {toCurrency((this.state.commSummary.profit * .10))}
        //         <Header.Subheader>
        //             Total commission
        // </Header.Subheader>
        //     </Header>
        //     : ''

        const userEmailUI = this.state.algoliaUser
            ? <h5>Email:{this.state.algoliaUser.label} || filter:{this.state.filter} || id:{this.state.algoliaUser.idadmins}</h5>
            : ''

        const showExtraSalesChargesUI = this.state.user && this.state.user.email == 'ivanmworozi@gmail.com'
            && this.state.salesPersonId == 10 && this.state.commSummary
            ? <div>
                standardCharges:{toCurrency(this.state.normalCharges)}<br />
                extraCharges: {toCurrency(this.state.extraCharges)}<br />
                total charges:{toCurrency(this.state.totalCharges)}<br />
            </div>
            : ''

        const closesSalesPersonProjectsCommissionPaidUI = this.state.salesPersonId 
        ? <Button color='red' onClick={this.closesSalesPersonProjectsCommissionPaid}>Close Projects</Button>
        :''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("ViewCurrentSales")
            ? <div>
                 <LargeProjectsNav showCommissionButton={this.state.showCommissionButton} />
                {userEmailUI}
                <h4>Comm is calculated on orders that are marked delivered AND paid:{this.state.filter}</h4>
                {salesPeopleDropDown}

                <br/>
                {closesSalesPersonProjectsCommissionPaidUI}

                {changeFilterButton}

                {numProjects}
                {totalProfit}
                {/* {totalCommission} */}

                {showExtraSalesChargesUI}

                {projectCommSummary}
            </div>
            : <h4>loading error a78</h4>

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
               
               {wholeUI}


                {/* {projectList} */}
            </div>
        );
    }
}

export default ViewCurrentSales;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ViewCurrentSales.js